<template>
  <base-section id="theme-features">
    <v-container>
      <v-row>
        <v-col v-for="(feature, i) in features" :key="i" cols="12" md="4">
          <base-avatar-card v-bind="feature" align="left" horizontal />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionThemeFeatures",

  data: () => ({
    features: [
      {
        title: "Job placement services for foreign maids",
        icon: "mdi-finance",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        title: "Direct hire your own foreign maids",
        icon: "mdi-fountain-pen-tip",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        title: "Placement of transfer maids",
        icon: "mdi-currency-usd",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        dark: true,
        title: "Home Leave Processing",
        icon: "mdi-cellphone",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        dark: true,
        title: "Application of work permits",
        icon: "mdi-pencil-box-outline",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        dark: true,
        title: "Renewal of passports and work permits",
        icon: "mdi-help-circle-outline",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        title: "Embassy endorsement",
        icon: "mdi-handshake",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        title: "Cancellation of work permits",
        icon: "mdi-trademark",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        title: "Booking and Purchasing of air tickets",
        icon: "mdi-align-vertical-center",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        dark: true,
        title: "Purchasing of banker guarantee and insurance for maids",
        icon: "mdi-export-variant",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        dark: true,
        title: "Repatriation of maids",
        icon: "mdi-file-document-edit",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      }
    ]
  })
};
</script>
